import Markdown from "react-markdown";
import { useIntl } from "react-intl";
import { useState } from "react";

import meeting1 from "../../../../../assets/icon/meeting-1.svg";
import table from "../../../../../assets/icon/mesa-1.svg";
import boardMeeting from "../../../../../assets/icon/board-meeting 1.svg";
import conference from "../../../../../assets/icon/conferencia-1.svg";

interface AccordionItem {
  id: string;
  title: string;
  icon: JSX.Element;
  content: string;
}

export const MeetingModels = () => {
  const { formatMessage } = useIntl();
  const [expandedItem, setExpandedItem] = useState<string>("1on1");

  const toggleItem = (id: string) => {
    setExpandedItem(expandedItem === id ? "" : id);
  };

  const accordionItems: AccordionItem[] = [
    {
      id: "1on1",
      title: formatMessage({
        id: "GUIDE_FOR_EXPERT_ACCORDION_TITLE",
      }),
      icon: <img src={meeting1} alt="Meeting 1" />,
      content: formatMessage({
        id: "GUIDE_FOR_EXPERT_ACCORDION_CONTENT",
      }),
    },
    {
      id: "small-group",
      title: formatMessage({
        id: "GUIDE_FOR_EXPERT_ACCORDION_TITLE_2",
      }),
      icon: <img src={table} alt="Meeting 2" />,
      content: formatMessage({
        id: "GUIDE_FOR_EXPERT_ACCORDION_CONTENT_2",
      }),
    },
    {
      id: "group-meeting",
      title: formatMessage({
        id: "GUIDE_FOR_EXPERT_ACCORDION_TITLE_3",
      }),
      icon: <img src={boardMeeting} alt="Meeting 2" />,
      content: formatMessage({
        id: "GUIDE_FOR_EXPERT_ACCORDION_CONTENT_3",
      }),
    },
    {
      id: "conversas-guiadas",
      title: formatMessage({
        id: "GUIDE_FOR_EXPERT_ACCORDION_TITLE_4",
      }),
      icon: <img src={conference} alt="Meeting 2" />,
      content: formatMessage({
        id: "GUIDE_FOR_EXPERT_ACCORDION_CONTENT_4",
      }),
    },
  ];

  return (
    <section className="pt-16">
      <div className="container mx-auto max-w-4xl">
        <div className="flex justify-center">
          <div className="w-full">
            <Markdown
              components={{
                p: ({ children, ...rest }) => (
                  <p
                    className="w-fit mx-auto mb-8 px-8 pt-6 text-2xl text-center border-t-1 border-t-black"
                    {...rest}
                  >
                    {children}
                  </p>
                ),
              }}
            >
              {formatMessage({
                id: "GUIDE_FOR_EXPERT_MEETING_MODEL_TITLE",
              })}
            </Markdown>
            <div id="accordion">
              {accordionItems.map((item) => (
                <div
                  key={item.id}
                  className="bg-white overflow-hidden transition-all duration-300 py-2 px-2"
                >
                  <button
                    onClick={() => toggleItem(item.id)}
                    className="w-full flex items-center justify-between p-4 bg-white hover:bg-gray-50 transition-colors shadow-md rounded-full z-10 relative"
                    aria-expanded={expandedItem === item.id}
                  >
                    <div className="flex items-center gap-4">
                      <div className="w-14 h-14 rounded-full bg-primary-light flex items-center justify-center border-2 border-primary-light flex-shrink-0">
                        {item.icon}
                      </div>
                      <Markdown
                        components={{
                          p: ({ children, ...rest }) => (
                            <p className="text-lg text-gray-800" {...rest}>
                              {children}
                            </p>
                          ),
                        }}
                      >
                        {item.title}
                      </Markdown>
                    </div>
                    <svg
                      className={`w-6 h-6 text-primary-light transition-transform duration-300 flex-shrink-0 ${
                        expandedItem === item.id ? "rotate-180" : ""
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </button>
                  <div
                    className={`transition-all duration-300 ease-in-out ${
                      expandedItem === item.id
                        ? "max-h-96 opacity-100"
                        : "max-h-0 opacity-0"
                    }`}
                  >
                    <div
                      className={`bg-primary-light text-white pt-16 p-6 rounded-2xl ${
                        expandedItem === item.id && "-mt-11"
                      }`}
                    >
                      <Markdown
                        components={{
                          li: ({ children, ...rest }) => (
                            <li
                              className="flex items-center gap-3 mb-1"
                              {...rest}
                            >
                              <span className="w-1 h-1 rounded-full bg-white" />
                              <span className="flex-1">{children}</span>
                            </li>
                          ),
                          ul: ({ children, ...rest }) => (
                            <ul className="list-none" {...rest}>
                              {children}
                            </ul>
                          ),
                        }}
                      >
                        {item.content}
                      </Markdown>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
